import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import { Actions, ActionTypes } from '../actions/plasticAddressActions';
export interface IPlasticAdressState {
  type?: ActionTypes;
  status?: ActionStatus;
  showPlasticAddressModal: boolean;
}

const initialState: IPlasticAdressState = {
  showPlasticAddressModal: false
};

export default function plasticAddressReducer(state = initialState, action: Actions): IPlasticAdressState {
  switch (action.type) {
    case ActionTypes.ShowPlasticAddressModal:
      return { ...state, showPlasticAddressModal: true };
    case ActionTypes.HidePlasticAddressModal:
      return { ...state, showPlasticAddressModal: false };
    default:
      return state;
  }
}
